import React from "react";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  FormGroup,
  Button,
  ButtonGroup,
  Input,
  Collapse,
  UncontrolledTooltip,
  Navbar,
  Form,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { reloadMap, getHeatmap } from "../redux/actions/map.action";
import { MapInteractionCSS } from "../assets/map-interaction";
import Heatmap from "simpleheat";
import Slider from "nouislider";
import items from "../variables/items";
import mapExample from "assets/img/mapExample.png";
const gridSize = 146.33;

function formatDate(ts) {
  var date = new Date(ts * 1000);
  var month = ("0" + (date.getMonth() + 1)).substr(-2);
  var day = ("0" + date.getDate()).substr(-2);
  var hour = ("0" + date.getHours()).substr(-2);
  var minutes = ("0" + date.getMinutes()).substr(-2);
  return month + "/" + day + " " + hour + ":" + minutes;
}

class Map extends React.Component {
  constructor() {
    super();
    this.mapWindow = React.createRef();
    this.mapRender = React.createRef();
    this.mapRaw = React.createRef();
    this.mapGrid = React.createRef();
    this.mapInteraction = React.createRef();
    this.slider = React.createRef();
    this.isLoaded = false;
    this.heat = undefined;
    this.state = {
      showGrid: true,
      showMonuments: true,
      showPlayers: true,
      showVendings: true,
      inspect: {
        show: false,
        minimised: false,
        player: undefined,
      },
      options: {
        startTime: 0,
        endTime: 0,
      },
      optionsOpened: true,
      heatmap: undefined,
      filter: "",
      vendingOffers: [],
      vendingResearch: [],
    };
    this.updateTimeout = undefined;
    this.centerMap = this.centerMap.bind(this);
    this.centerPlayer = this.centerPlayer.bind(this);
    this.inspectPlayer = this.inspectPlayer.bind(this);
    this.reopenInspect = this.reopenInspect.bind(this);
    this.closeInspect = this.closeInspect.bind(this);
    this.onSliderChange = this.onSliderChange.bind(this);
    this.drawHeatmap = this.drawHeatmap.bind(this);
    this.setVendingFilter = this.setVendingFilter.bind(this);
    this.getItemImg = this.getItemImg.bind(this);
    this.getItemName = this.getItemName.bind(this);
    this.centerOffer = this.centerOffer.bind(this);
  }

  formatOffer(offer) {
    const item = items.find((e) => e.id === offer.itemId.toString());
    const currency = items.find((e) => e.id === offer.currencyId.toString());
    if (item && currency) {
      if (
        this.state.filter.length &&
        item.name.toLowerCase().indexOf(this.state.filter) === -1
      )
        return <></>;
      if (!offer.amountInStock)
        return (
          <div className={"outofstock"}>
            <b>
              {offer.quantity} {item.name}
            </b>{" "}
            →{" "}
            <b>
              {offer.costPerItem} {currency.name}
            </b>
          </div>
        );
      if (offer.amountInStock === 1)
        return (
          <div className={"oneleft"}>
            <b>
              {offer.quantity} {item.name}
            </b>{" "}
            →{" "}
            <b>
              {offer.costPerItem} {currency.name}
            </b>{" "}
            (1)
          </div>
        );
      return (
        <div className={"available"}>
          <b>
            {offer.quantity} {item.name}
          </b>{" "}
          →{" "}
          <b>
            {offer.costPerItem} {currency.name}
          </b>{" "}
          ({offer.amountInStock})
        </div>
      );
    }
    return <></>;
  }

  matchVendingFilter(vending) {
    if (!this.state.filter.length) return true;
    if (!vending.sellOrders || !vending.sellOrders.length) return false;
    for (const offer of vending.sellOrders) {
      const item = items.find((e) => e.id === offer.itemId.toString());
      if (item && item.name.toLowerCase().indexOf(this.state.filter) > -1)
        return true;
    }
    return false;
  }

  hasAvailableOffers(vendings) {
    /*if (!vending.sellOrders)
            return 'noOffers';
        for (const offer of vending.sellOrders)
            if (offer.amountInStock)
                return 'hasOffers';
        return 'noOffers';*/
    if (!vendings.find((o) => o.sellOrders.length)) return "noOffers";
    var results = vendings.filter((v) => v.sellOrders);
    for (const offer of results)
      for (const orders of offer.sellOrders)
        if (orders.amountInStock) return "hasOffers";
    return "noOffers";
  }

  onSliderChange(values) {
    const now = Math.floor(Date.now() / 1000);
    const diff = now - this.props.mapData.infos.wipeTime;
    var start = parseInt(values[0]);
    if (start < 0) start = 0;
    var end = parseInt(values[1]);
    if (end > 100) end = 100;
    var startTime =
      start === 0
        ? 0
        : Math.floor(this.props.mapData.infos.wipeTime + (start * diff) / 100);
    var endTime =
      end === 100
        ? 0
        : Math.floor(this.props.mapData.infos.wipeTime + (end * diff) / 100);
    this.setState({
      options: {
        startTime,
        endTime,
      },
    });
    this.updateTimeout && clearTimeout(this.updateTimeout);
    if (
      (this.state.inspect &&
        this.state.inspect.player &&
        (!this.props.heatmap ||
          !this.props.heatmap.target ||
          this.state.inspect.player.steamId.toString() !==
            this.props.heatmap.target)) ||
      this.props.heatmap.startTime !== this.state.options.startTime ||
      this.props.heatmap.endTime !== this.state.options.endTime
    )
      this.updateTimeout = setTimeout(() => {
        if (this.state && this.state.inspect && this.state.inspect.player) {
          this.props
            .getHeatmap(
              this.state.inspect.player.steamId,
              this.state.options.startTime,
              this.state.options.endTime
            )
            .then(() => {
              if (this.state.heatmap && this.props.heatmap[this.state.heatmap])
                this.renderHeatmap(this.props.heatmap[this.state.heatmap]);
            });
        }
      }, 500);
  }

  async componentDidMount() {
    await this.props.reloadMap();
    window.addEventListener("resize", this.centerMap);
    //window.addEventListener('scroll', this.handleScroll);
  }

  inspectPlayer(player) {
    if (!this.props.heatmap || !this.props.heatmap.target)
      this.props.getHeatmap(
        player.steamId,
        this.state.options.startTime,
        this.state.options.endTime
      );
    this.setState({
      heatmap: undefined,
      inspect: {
        show: true,
        minimised: false,
        player,
      },
    });
  }

  reopenInspect() {
    this.setState({
      inspect: {
        show: true,
        minimised: false,
        player: this.state.inspect.player,
      },
    });
  }

  closeInspect() {
    this.setState({
      inspect: {
        show: false,
        player: undefined,
      },
      heatmap: undefined,
    });
  }

  centerPlayer(player) {
    //this.inspectPlayer(player);
    if (
      !player.isOnline ||
      !this.mapWindow ||
      !this.mapWindow.current ||
      !this.mapInteraction ||
      !this.mapInteraction.current
    )
      return;
    const restX = this.mapWindow.current.offsetWidth - this.props.size;
    const restY = this.mapWindow.current.offsetHeight - this.props.size;
    const plyX = player.x * this.props.ratio + this.props.adjust;
    const plyY = player.y * this.props.ratio + this.props.adjust;
    this.mapInteraction.current(1, {
      x: restX / 2 + this.props.size / 2 - plyX,
      y: restY / 2 + this.props.size / 2 - (this.props.size - plyY),
    });
  }
  centerOffer(offer) {
    if (
      !this.mapWindow ||
      !this.mapWindow.current ||
      !this.mapInteraction ||
      !this.mapInteraction.current
    )
      return;
    const restX = this.mapWindow.current.offsetWidth - this.props.size;
    const restY = this.mapWindow.current.offsetHeight - this.props.size;
    const plyX = offer.x * this.props.ratio + this.props.adjust;
    const plyY = offer.y * this.props.ratio + this.props.adjust;
    this.mapInteraction.current(1, {
      x: restX / 2 + this.props.size / 2 - plyX,
      y: restY / 2 + this.props.size / 2 - (this.props.size - plyY),
    });
  }

  centerMap() {
    if (
      !this.mapWindow ||
      !this.mapWindow.current ||
      !this.mapInteraction ||
      !this.mapInteraction.current
    )
      return;
    const restX = this.mapWindow.current.offsetWidth - this.props.size * 0.4;
    const restY = this.mapWindow.current.offsetHeight - this.props.size * 0.4;
    this.mapInteraction.current(0.4, {
      x: restX / 2,
      y: restY / 2,
    });
  }

  renderGrid() {
    if (!this.mapGrid || !this.mapGrid.current) return;
    const context = this.mapGrid.current.getContext("2d");
    const space = this.props.ratio * gridSize;
    const min = this.props.adjust;
    var max = this.props.size - this.props.adjust;
    const rest = Math.abs((max - min) % space);
    max -= rest;
    context.font = "12px 'Poppins'";
    context.strokeStyle = "black";
    context.lineWidth = 1;
    context.globalAlpha = 0.9;
    for (var x = 0; min + space * x < max + 1; x++) {
      const step = min + space * x;
      context.beginPath();
      context.moveTo(step, min);
      context.lineTo(step, max);
      context.stroke();
      for (
        var sub = 0;
        min + sub * space < max && min + space * x < max;
        sub++
      ) {
        var letters =
          x < 26
            ? String.fromCharCode(x + 65)
            : String.fromCharCode(65, x - 26 + 65);
        context.fillText(`${letters}${sub}`, step + 5, min + space * sub + 15);
      }
    }
    for (var y = 0; min + space * y < max + 1; y++) {
      const step = min + space * y;
      context.beginPath();
      context.moveTo(min, step);
      context.lineTo(max, step);
      context.stroke();
    }
  }
  getOffers() {
    if (!this.props.vendings.length) return;
    var tempArray = [];
    this.props.vendings.map((vending) => {
      if (!vending.sellOrders || !vending.sellOrders.length) return false;
      for (const offer of vending.sellOrders) {
        if (offer.amountInStock) {
          const item = items.find((e) => e.id === offer.itemId.toString());
          if (item) {
            tempArray.push({
              ...offer,
              name: item.name.toLowerCase(),
              x: vending.x,
              y: vending.y,
            });
          }
        }
      }
      return this.setState({ vendingOffers: tempArray });
    });
  }
  renderMap() {
    if (
      !this.mapRender ||
      !this.mapRender.current ||
      !this.mapRaw ||
      !this.mapRaw.current
    )
      return;
    const render = this.mapRender.current.getContext("2d");
    this.mapRaw.current.onload = () => {
      render.drawImage(
        this.mapRaw.current,
        -this.props.mapData.map.oceanMargin + this.props.adjust,
        -this.props.mapData.map.oceanMargin + this.props.adjust
      );
    };
  }

  async drawHeatmap(player, opt) {
    if (
      this.props.heatmap.startTime !== this.state.options.startTime ||
      this.props.heatmap.endTime !== this.state.options.endTime ||
      this.props.heatmap.target !== player.steamId.toString()
    )
      this.props
        .getHeatmap(
          player.steamId,
          this.state.options.startTime,
          this.state.options.endTime
        )
        .then(() => {
          if (this.props.heatmap[opt]) {
            this.renderHeatmap(this.props.heatmap[opt]);
            this.setState({ heatmap: opt });
          }
        });
    else if (this.props.heatmap[opt]) {
      this.renderHeatmap(this.props.heatmap[opt]);
      this.setState({ heatmap: opt });
    }
  }

  async renderHeatmap(values) {
    this.heat = Heatmap("heatmap");
    this.heat.data(values);
    this.heat.max(2);
    this.heat.radius(20, 15);
    this.heat.draw(0.5);
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.isLoaded && this.mapWindow.current) {
      this.renderMap();
      this.renderGrid();
      this.centerMap();
      Slider.create(this.slider.current, {
        start: [0, 100],
        connect: [false, true, false],
        step: 1,
        range: { min: 0, max: 100 },
      });
      this.slider.current.noUiSlider.on("change", this.onSliderChange);
      this.isLoaded = true;
    }
    if (prevProps.vendings !== this.props.vendings) {
      this.getOffers();
    }
  }

  async componentWillUnmount() {
    //window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener("resize", this.centerMap);
  }

  async setVendingFilter(event) {
    this.setState({
      filter: event.target.value ? event.target.value.toLowerCase() : "",
      vendingResearch: event.target.value
        ? this.state.vendingOffers.filter(
            (o) => o.name.indexOf(event.target.value) > -1
          )
        : [],
    });
  }

  async handleScroll(event) {
    console.log(event);
  }

  isMapAvailable() {
    if (this.props.vip.plan < 3 || this.props.error) return false;
    return true;
  }
  getErrorBtn() {
    if (this.props.error === "9005" || this.props.vip.plan < 3) {
      return (
        <Button className="errorBtn" tag={Link} to="/plans">
          {this.props.t("pages:plans")}
        </Button>
      );
    } else if (this.props.error === "NO_SELECTED_SERVER") {
      return (
        <Button className="errorBtn" tag={Link} to="/setup">
          {this.props.t("pages:setup")}
        </Button>
      );
    }
  }
  getItemName = (id) => {
    if (!id) return false;
    const index = items.findIndex((i) => i.id === id.toString());
    if (index < 0) return false;
    return items[index].name;
  };
  getItemImg = (id) => {
    if (!id) return false;
    const index = items.findIndex((i) => i.id === id.toString());
    if (index < 0) return false;
    return `https://rustlink.io/api/image/${items[index].short}/32`;
  };
  getVendingsFormated = () => {
    if (!this.props.vendings) return false;
    var copyVending = [...JSON.parse(JSON.stringify(this.props.vendings))];
    var newVending = [];
    var maxDistance = 50;
    copyVending.forEach(function (v) {
      if (v.grouped) return;
      var regrouped = [];
      regrouped.push(v);
      copyVending.forEach(function (v2) {
        if (v === v2) return;
        if (v2.grouped || v.grouped) return;
        if (
          ((v.x > v2.x && v.x - v2.x <= maxDistance) ||
            (v2.x > v.x && v2.x - v.x <= maxDistance)) &&
          ((v.y > v2.y && v.y - v2.y <= maxDistance) ||
            (v2.y > v.y && v2.y - v.y <= maxDistance))
        ) {
          regrouped.push(v2);
          v2.grouped = true;
        }
      });
      v.grouped = true;
      newVending.push(regrouped);
    });
    return newVending;
  };
  render() {
    if (
      this.props.mapData &&
      this.props.mapData.infos &&
      this.props.mapData.map &&
      this.props.mapData.map.monuments
    ) {
      //const userPlan = this.props?.vip?.plan;
      //if (userPlan < 3) this.props.error = "9005";
      return (
        <>
          <div className="content">
            <div className="mapContent">
              <Navbar expand="lg" color="primary" className="navMap">
                <div className="serverName">
                  {this.props.mapData.infos.name}
                </div>
                <Form inline className={`ml-auto`}>
                  <FormGroup className="no-border">
                    <Input
                      disabled={
                        !this.state.showVendings || !this.isMapAvailable()
                      }
                      type="text"
                      onChange={(e) => {
                        this.setVendingFilter(e);
                      }}
                      placeholder={this.props.t("searchFor")}
                    />
                  </FormGroup>
                </Form>
              </Navbar>
              <div
                ref={this.mapWindow}
                className={`${
                  !this.isMapAvailable() ? `mapWindow mapBlurred` : `mapWindow`
                }`}
                style={{ background: this.props.mapData.map.background }}
              >
                <div className="mapOptions">
                  <div>
                    <Input
                      type="checkbox"
                      defaultChecked={true}
                      onChange={(e) => {
                        this.setState({ showGrid: e.target.checked });
                      }}
                    />{" "}
                    {this.props.t(`grid`)}
                    <span className="form-check-sign">
                      <span className="check"></span>
                    </span>
                  </div>
                  <div>
                    <Input
                      type="checkbox"
                      defaultChecked={true}
                      onChange={(e) => {
                        this.setState({ showPlayers: e.target.checked });
                      }}
                    />{" "}
                    {this.props.t(`players`)}
                    <span className="form-check-sign">
                      <span className="check"></span>
                    </span>
                  </div>
                  <div>
                    <Input
                      type="checkbox"
                      defaultChecked={true}
                      onChange={(e) => {
                        this.setState({ showMonuments: e.target.checked });
                      }}
                    />{" "}
                    {this.props.t(`monuments`)}
                    <span className="form-check-sign">
                      <span className="check"></span>
                    </span>
                  </div>
                  <div>
                    <Input
                      type="checkbox"
                      defaultChecked={true}
                      onChange={(e) => {
                        this.setState({ showVendings: e.target.checked });
                      }}
                    />{" "}
                    {this.props.t(`vendings`)}
                    <span className="form-check-sign">
                      <span className="check"></span>
                    </span>
                  </div>
                </div>
                {this.state.vendingResearch &&
                  this.state.vendingResearch.length > 0 && (
                    <div className="vendingResults">
                      {this.state.vendingResearch.map((v) => {
                        return (
                          <div
                            className="vendingOffers"
                            onClick={() => {
                              this.centerOffer(v);
                            }}
                          >
                            <Row className="vendingOffer">
                              <Col xs="5" className="vendingItem">
                                <img
                                  className="vendingItemImg"
                                  alt={this.getItemName(v.currencyId)}
                                  src={this.getItemImg(v.currencyId)}
                                />
                                <div className="vendingItemValue">
                                  x{v.costPerItem}
                                </div>
                              </Col>
                              <Col xs="2" className="m-auto">
                                →
                              </Col>
                              <Col xs="5" className="vendingItem">
                                <img
                                  className="vendingItemImg"
                                  alt={v.name}
                                  src={this.getItemImg(v.itemId)}
                                />
                                <div className="vendingItemValue">
                                  x{v.quantity}
                                </div>
                              </Col>
                            </Row>
                          </div>
                        );
                      })}
                    </div>
                  )}
                <Card className="playerPanel">
                  {this.state.showPlayers && this.props.mapData.team
                    ? this.props.mapData.team.map((player) => {
                        const name = `pply-${player.steamId}`;
                        return (
                          <>
                            <div
                              key={name}
                              id={name}
                              onClick={() => {
                                this.centerPlayer(player);
                              }}
                              className={
                                player.isOnline
                                  ? player.isAlive
                                    ? "player alive"
                                    : "player dead"
                                  : "player disconnect"
                              }
                              style={{
                                backgroundImage: `url(${player.avatar})`,
                              }}
                            ></div>
                            <UncontrolledTooltip
                              placement="left"
                              delay={0}
                              target={name}
                            >
                              {player.name}
                            </UncontrolledTooltip>
                          </>
                        );
                      })
                    : ``}
                </Card>
                <Card
                  className={`inspectPanel ${
                    this.state.inspect.show ? "" : "hidden"
                  }`}
                >
                  <div
                    className={`nickname ${
                      this.state.optionsOpened ? "opened" : ""
                    }`}
                  >
                    {this.props.t("inspect.inspecting")}{" "}
                    <b
                      onClick={() => {
                        this.state.inspect.player &&
                          window.open(
                            `https://steamcommunity.com/profiles/${this.state.inspect.player.steamId}`,
                            "_blank"
                          );
                      }}
                    >
                      {this.state.inspect.player
                        ? this.state.inspect.player.name
                        : ""}
                    </b>
                    <div
                      onClick={() => {
                        this.setState({
                          optionsOpened: !this.state.optionsOpened,
                        });
                      }}
                      className={`options`}
                    >
                      {this.state.optionsOpened ? "-" : "+"}
                    </div>
                    <div
                      onClick={() => {
                        this.closeInspect(true);
                      }}
                      className={`closeInspect`}
                    >
                      x
                    </div>
                  </div>
                  <Collapse isOpen={this.state.optionsOpened}>
                    <div className="heatselect">
                      <ButtonGroup size="sm">
                        <Button
                          onClick={() =>
                            this.drawHeatmap(
                              this.state.inspect.player,
                              "positions"
                            )
                          }
                          className={
                            this.state.heatmap === `positions`
                              ? `BtnSelected`
                              : ``
                          }
                        >
                          {this.props.t("inspect.positions")}
                        </Button>
                        <Button
                          onClick={() =>
                            this.drawHeatmap(
                              this.state.inspect.player,
                              "deaths"
                            )
                          }
                          className={
                            this.state.heatmap === `deaths` ? `BtnSelected` : ``
                          }
                        >
                          {this.props.t("inspect.deaths")}
                        </Button>
                      </ButtonGroup>
                    </div>
                    <div className="timeselect">
                      <div
                        className="slider slider-primary mb-3"
                        ref={this.slider}
                      />
                      <Row className="datepick">
                        <Col>
                          {this.state.options.startTime
                            ? formatDate(this.state.options.startTime)
                            : this.props.t("inspect.wipeStart")}
                        </Col>
                        <Col>
                          {this.state.options.endTime
                            ? formatDate(this.state.options.endTime)
                            : this.props.t("inspect.wipeEnd")}
                        </Col>
                      </Row>
                    </div>
                  </Collapse>
                </Card>
                <MapInteractionCSS
                  setFunc={this.mapInteraction}
                  minScale={0.4}
                  maxScale={1.4}
                  disableZoom={!this.isMapAvailable()}
                  disablePan={!this.isMapAvailable()}
                >
                  {/* <div className="mwrap render" style={{backgroundImage: `url(https://rustlink.io/api/loadmap?v=${this.props.mapData.infos.map+this.props.mapData.infos.seed+this.props.mapData.infos.salt}`}}></div>*/}
                  <canvas
                    ref={this.mapRender}
                    width={this.props.size}
                    height={this.props.size}
                    className="render"
                  ></canvas>
                  <canvas
                    ref={this.mapGrid}
                    width={this.props.size}
                    height={this.props.size}
                    className={`grid mwrap ${
                      this.state.showGrid ? "show" : "hidden"
                    }`}
                  ></canvas>
                  <canvas
                    id="heatmap"
                    width={this.props.size}
                    height={this.props.size}
                    className={`heatmap mwrap ${
                      this.state.heatmap ? "" : "hidden"
                    }`}
                  ></canvas>
                  <div className="mwrap markers">
                    {this.state.showMonuments
                      ? this.props.mapData.map.monuments
                          .filter(
                            (e) =>
                              e.token !== "DungeonBase" &&
                              e.token !== "train_tunnel_display_name"
                          )
                          .map((monument) => {
                            const name = `monument-${Math.floor(
                              monument.x
                            )}${Math.floor(monument.y)}`;
                            return (
                              <div
                                key={name}
                                id={name}
                                className="marker monument"
                                style={{
                                  bottom:
                                    monument.y * this.props.ratio +
                                    this.props.adjust -
                                    16,
                                  left:
                                    monument.x * this.props.ratio +
                                    this.props.adjust -
                                    16,
                                }}
                              >
                                <img
                                  alt={monument.token}
                                  src={`https://rustlink.io/static/media/${monument.token}.svg`}
                                ></img>
                                <UncontrolledTooltip delay={0} target={name}>
                                  {this.props.t(`monument.${monument.token}`)}
                                </UncontrolledTooltip>
                                {/*<span>{this.props.t(`monument.${monument.token}`)}</span>*/}
                              </div>
                            );
                          })
                      : ``}
                    {this.state.showPlayers &&
                    !this.state.heatmap &&
                    this.props.mapData.team
                      ? this.props.mapData.team.map((player) => {
                          const name = `player-${player.steamId}`;
                          if (!player.isOnline) return <></>;
                          return (
                            <div
                              key={name}
                              id={name}
                              className="marker player"
                              style={{
                                bottom:
                                  player.y * this.props.ratio +
                                  this.props.adjust -
                                  16,
                                left:
                                  player.x * this.props.ratio +
                                  this.props.adjust -
                                  16,
                              }}
                            >
                              <div
                                /*onClick={() => { this.inspectPlayer(player); }}*/ className={
                                  player.isAlive ? "alive" : "dead"
                                }
                                style={{
                                  backgroundImage: `url(${player.avatar})`,
                                }}
                              ></div>
                              <UncontrolledTooltip delay={0} target={name}>
                                {player.name}
                              </UncontrolledTooltip>
                            </div>
                          );
                        })
                      : ``}
                    {this.state.showVendings &&
                    !this.state.heatmap &&
                    this.props.vendings &&
                    this.props.vendings
                      ? this.getVendingsFormated().map((vendings) => {
                          const name = `vending-${vendings[0].id}`;
                          return (
                            <div
                              key={name}
                              id={name}
                              className={`marker vending ${this.hasAvailableOffers(
                                vendings
                              )}`}
                              style={{
                                bottom:
                                  vendings[0].y * this.props.ratio +
                                  this.props.adjust -
                                  6,
                                left:
                                  vendings[0].x * this.props.ratio +
                                  this.props.adjust -
                                  6,
                              }}
                            >
                              <div className="vendingsNumber">
                                <img
                                  alt={`vending-${vendings[0].id}`}
                                  src={
                                    "https://rustlink.io/static/media/vending.png"
                                  }
                                />
                                <div className="number">
                                  {vendings.length > 1 && vendings.length}
                                </div>
                              </div>
                              <UncontrolledTooltip
                                delay={0}
                                target={name}
                                innerClassName="vendingTip"
                              >
                                {vendings.map((vending) => {
                                  return (
                                    <>
                                      {vending.name} <br></br>
                                      {vending.sellOrders
                                        ? vending.sellOrders.map((e) => {
                                            return this.formatOffer(e);
                                          })
                                        : ""}
                                    </>
                                  );
                                })}
                              </UncontrolledTooltip>
                            </div>
                          );
                        })
                      : ``}
                  </div>
                </MapInteractionCSS>
              </div>
              <div
                className={
                  !this.isMapAvailable() ? `mapBlurredCentered` : `hidden`
                }
              >
                {this.props.error && (
                  <>
                    <div className="displayError">
                      {this.props.t(`errors.${this.props.error}`)}
                    </div>
                    {this.getErrorBtn()}
                  </>
                )}
              </div>
            </div>
            {/*<div className="rustMaps selectable" onClick={()=> window.open("https://rustmaps.com", "_blank")}>{this.props.t('icons')}</div>*/}
          </div>
          <div className="ps_r">
            <img
              ref={this.mapRaw}
              className="hidden"
              alt="map"
              src={
                this.isMapAvailable()
                  ? `https://rustlink.io/api/loadmap?map=${this.props.mapData.infos.map}&wipe=${this.props.mapData.infos.wipeTime}`
                  : mapExample
              }
            ></img>
          </div>
        </>
      );
    } else
      return (
        <>
          <div className="content">{this.props.t(`loading`)}..</div>
        </>
      );
  }
}

const mapDispatchToProps = {
  reloadMap,
  getHeatmap,
};

const mapStateToProps = (state) => {
  const { vip } = state.infos;
  const { logged } = state.rLink;
  const { mapData, ratio, size, adjust, heatmap, vendings, error } = state.map;
  return {
    vip,
    logged,
    mapData,
    ratio,
    size,
    adjust,
    heatmap,
    vendings,
    error,
  };
};

export default withTranslation(["map", "settings", "pages"])(
  connect(mapStateToProps, mapDispatchToProps)(Map)
);
